import { useLayoutEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { uiStore } from 'shared/store/uiStore'
import { useChatbotContext } from 'pages/chatbot/context/chatbotContext'

export const AgentBookAppointmentAccessLayoutContent = observer(() => {
  const store = useChatbotContext()

  useLayoutEffect(() => {
    if (store.model.settings.currentStep) {
      const currentStep = store.model.settings.currentStep?.slice(-1)
      store.agentNavigationStore.setCurrentStep(Number(currentStep))
    }

    uiStore.changeRouteViaVue({
      method: 'replace',
      path: store.agentNavigationStore.getCurrentUrl,
    })
  }, [store.model.type])

  return (
    <>
      <Outlet />
    </>
  )
})

export const AgentBookAppointmentAccessLayout = () => <AgentBookAppointmentAccessLayoutContent />
